import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ButtonsContainerComponent,
  NgCommonModule,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IPractice } from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef } from '@principle-theorem/shared';

interface IPracticeHeidiSettings {
  email: string;
  testMode: boolean;
}

@Component({
  selector: 'pr-practice-heidi-settings',
  imports: [
    NgCommonModule,
    MatFormFieldModule,
    MatInput,
    MatButton,
    MatIcon,
    MatSlideToggle,
    ButtonsContainerComponent,
  ],
  templateUrl: './practice-heidi-settings.component.html',
  styleUrl: './practice-heidi-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeHeidiSettingsComponent {
  private _snackBar = inject(MatSnackBar);
  practice = input.required<WithRef<IPractice>>();
  heidiSignupUrl = 'https://www.heidihealth.com/en-au';
  form = new TypedFormGroup<IPracticeHeidiSettings>({
    email: new TypedFormControl<string>('', Validators.email),
    testMode: new TypedFormControl<boolean>(false),
  });

  constructor() {
    effect(() => {
      const practice = this.practice();
      if (!practice.metadata?.heidi) {
        return;
      }
      this.form.setValue({
        email: practice.metadata.heidi.email ?? '',
        testMode: !!practice.metadata.heidi.testMode,
      });
    });
  }

  async save(): Promise<void> {
    if (!this.form.valid) {
      return;
    }
    const formData = this.form.getRawValue();
    const practice = this.practice();
    await Firestore.patchDoc(practice.ref, {
      metadata: {
        ...practice.metadata,
        heidi: {
          ...practice.metadata?.heidi,
          ...formData,
        },
      },
    });
    this._snackBar.open('Heidi Health settings changed');
  }
}
